//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SlideItems from '../common/slideItems';
import breakpoints from '../../mixins/breakpoints.mixin';

export default {
  name: 'MainNavigation',
  components: {
    SlideItems,
  },
  mixins: [breakpoints],
  props: ['activeIndex', 'links'],
  data() {
    return {
      wasMove: false,
    };
  },
  methods: {
    touchmove() {
      this.wasMove = true;
    },
    touchend(e, url) {
      if (!this.wasMove) {
        e.stopPropagation();
        this.$router.push(url);
      }

      this.wasMove = false;
    },
  },
};
